import React from 'react';
import styled from 'styled-components';

import { ButtonGroup, Text, ToggleButton } from '@zillow/constellation';
import { Col, Row } from '@zillow/zrs-comet';

import type { HTMLElementEvent } from '../../../../../shared/models/Types';
import { SNOW_REMOVAL } from '../../../../../shared/constants';

type Props = {
  setButtonGroupClick: (fieldName: string, buttonValue: string) => void;
  areaName?: string;
  fieldName: string;
  buttonValue: string;
};

const MiddleAligned = styled.div`
  ${Col} {
    vertical-align: middle;
  }
`;

export default function AreaButtonGroup_v1({ setButtonGroupClick, areaName, fieldName, buttonValue }: Props) {
  function onButtonClick(event: HTMLElementEvent<typeof ToggleButton>): void {
    const { value } = event.currentTarget.dataset;
    setButtonGroupClick(fieldName, value);
  }

  return (
    <MiddleAligned>
      <Row paddingY="xs">
        <Col xs={3} sm={5}>
          {areaName ? <Text fontType="bodySmall">{areaName}</Text> : <Text>{'Who will be responsible?'}</Text>}
        </Col>
        <Col xs={9} sm={7}>
          <ButtonGroup conjoined fluid aria-label="snow removal responsibility">
            <ToggleButton
              pressed={buttonValue === SNOW_REMOVAL.LANDLORD}
              data-value={SNOW_REMOVAL.LANDLORD}
              data-test="AreaButtonGroup-landlord"
              onClick={onButtonClick}
            >
              Landlord
            </ToggleButton>
            <ToggleButton
              pressed={buttonValue === SNOW_REMOVAL.TENANT}
              data-value={SNOW_REMOVAL.TENANT}
              onClick={onButtonClick}
            >
              Tenant
            </ToggleButton>
            <ToggleButton
              pressed={buttonValue === SNOW_REMOVAL.NA}
              data-value={SNOW_REMOVAL.NA}
              onClick={onButtonClick}
            >
              N/A
            </ToggleButton>
          </ButtonGroup>
        </Col>
      </Row>
    </MiddleAligned>
  );
}
